module.exports = __webpack_public_path__ + "img/default_pattern_01_m.d08de4fc.png";